import { createContext, useContext } from 'react';
import environment from '../env';
import useSWRImmutable from 'swr/immutable';
import { useAuth } from './AuthProvider';

const NotificationsContext = createContext();

export const useNotifications = () => useContext(NotificationsContext);

const NotificationsProvider = ({ children }) => {
    const { accessToken } = useAuth();
    
    const defaultOptions = {
        method: "GET",
        headers: {
            "x-api-key": environment.CUSTOMER_PORTAL_API_KEY,
            "Authorization": `Bearer ${accessToken}`,
            "organisation": environment.CLIENT_NAME
        },
    };

    function useGetAccessibility() {
        const url = accessToken ? `${environment.CUSTOMER_PORTAL_API}/accessibility` : null;
        console.info("Get accessibility request", { defaultOptions, url })
        const { data, error, isLoading } = useSWRImmutable([url, defaultOptions])
        console.info("Get accessibility response", { data, error, isLoading })
        return {
            accessibility: data,
            error,
            isAccessibilityLoading: isLoading
        }
    }


    const contextValue = {
        useGetAccessibility,
    };

    return (
        <NotificationsContext.Provider value={contextValue}>
            {children}
        </NotificationsContext.Provider>
    );
};

export default NotificationsProvider;